/* eslint-disable complexity */
/* eslint max-params: ["error", 5] */

import './advance-part-tab.scss';
import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';
import LabeledDateInput from '../../../../../../claim/shared/components/claim-fields/labeled-date-input';
import LabeledInput from '../../../../../../claim/shared/components/claim-fields/labeled-input';
import PropTypes from 'prop-types';
import RgaConsignmentDetails from '../../../../../rga-search-results/state/rga-consignment-details';
import RgaDetails from '../../../../../rga-search-results/state/rga-details';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';
import WarrantyLoadingIndicator from '../../../../../../shared/components/warranty-loading-indicator';

function onChangeConsignmentFieldValue(propertyName, props, value) {

    props.actions.updateRgaConsignmentValues(propertyName, value);

}

function onSave() {

    this.actions.postRgaConsignmentValues(this.rgaConsignmentDetails);

}

function onCancel() {

    this.actions.getRgaConsignment(this.rgaDetails);

}
class ConsignmentDetails extends Component {

    componentWillMount() {

        this.props.actions.getRgaConsignment(this.props.rgaDetails);

    }

    componentWillUnmount() {

        this.props.actions.resetProperties('consignment');

    }
    render() {

        const {rgaConsignmentDetails} = this.props;

        return (
            <section className='rga-recalled-form'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <div className='row'>
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-cosignment' : 'part-request'}
                        isEditable={true}
                        label='Courier Name'
                        maxLength={30}
                        onChange={onChangeConsignmentFieldValue.bind(event, 'courierName', this.props)}
                        tabIndex='1'
                        value={rgaConsignmentDetails.courierName}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-cosignment' : 'part-request'}
                        isEditable={true}
                        label='Courier Tracking Number'
                        maxLength={30}
                        onChange={onChangeConsignmentFieldValue.bind(event, 'courierTrackingNo', this.props)}
                        tabIndex='1'
                        value={rgaConsignmentDetails.courierTrackingNo}
                    />
                    <LabeledInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-cosignment' : 'part-request'}
                        isEditable={true}
                        label='Requestor'
                        maxLength={30}
                        onChange={onChangeConsignmentFieldValue.bind(event, 'requester', this.props)}
                        tabIndex='1'
                        value={rgaConsignmentDetails.requester}
                    />
                </div>
                <div className='row'>
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='Request type'
                        maxLength={30}
                        onChange={null}
                        tabIndex='4'
                        value={rgaConsignmentDetails.requestType}
                    />
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='Requestor Type'
                        maxLength={30}
                        onChange={null}
                        tabIndex='4'
                        value={rgaConsignmentDetails.requesterType}
                    />
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='Special Instruction'
                        maxLength={30}
                        onChange={null}
                        tabIndex='7'
                        value={rgaConsignmentDetails.specialInstruction}
                    />
                </div>
                <div className='row'>
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='First Ship To Location'
                        maxLength={30}
                        onChange={null}
                        tabIndex='8'
                        value={rgaConsignmentDetails.firstShipToLocation}
                    />
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='Shipment Priority'
                        maxLength={30}
                        onChange={onChangeConsignmentFieldValue.bind(event, 'shippingPriority', this.props)}
                        tabIndex='9'
                        value={rgaConsignmentDetails.shippingPriority}
                    />
                    <LabeledDateInput
                        className={this.props.security.role === 'RGA_USER' ? 'disabled-field-cosignment' : 'part-request'}
                        date={rgaConsignmentDetails.shippedToDate}
                        isEditable={true}
                        isValid={true}
                        label='Date Shipped To Supplier'
                        onDateChange={onChangeConsignmentFieldValue.bind(event, 'shippedToDate', this.props)}
                        tabIndex='6'
                    />
                </div>
                <div className='row'>
                    <LabeledInput
                        className='disabled-field-cosignment'
                        isEditable={true}
                        label='Second Ship To Location'
                        onChange={null}
                        tabIndex='10'
                        value={rgaConsignmentDetails.secondShipToLocation}
                    />
                </div>
                <section className='button-group recalled-button-group'>
                    <button
                        className='secondary'
                        onClick={onCancel.bind(this.props)}
                    >
                        <FormattedMessage id='CANCEL'/>
                    </button>
                    <button
                        className='primary'
                        disabled={this.props.security.role === 'RGA_USER'}
                        onClick={onSave.bind(this.props)}
                    >
                        <FormattedMessage id='SAVE'/>
                    </button>
                </section>
            </section>
        );

    }
}

ConsignmentDetails.displayName = 'ConsignmentDetails';
ConsignmentDetails.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    rgaConsignmentDetails: PropTypes.instanceOf(RgaConsignmentDetails).isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default ConsignmentDetails;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/advance-returned-part-information/recalled-part-tab/components/consignment-details.js